import { h } from 'preact';
import Icon from '../icon';
import cx from 'classnames';
import style from './style';

const Button = ({ type='primary', size='regular', brand='', iconName, children, ...props }) => (
	<button {...props} class={cx(style.button, style[type], style[size], brand && style[`brand-${brand}`], props.class)} >
		{iconName && <Icon name={iconName} class={style.icon} />}
		{children}
	</button>
);

export default Button;
